var map = {
	"./+child-barrel.ngfactory": [
		"cK1S",
		2
	],
	"./+child-detail.ngfactory": [
		"NNTw",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "SfPD";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./$$_lazy_route_resource lazy
// module id = SfPD
// module chunks = 3